import { render } from "./AfterSalesExchangeGood.vue?vue&type=template&id=705221aa&scoped=true&ts=true"
import script from "./AfterSalesExchangeGood.vue?vue&type=script&lang=ts"
export * from "./AfterSalesExchangeGood.vue?vue&type=script&lang=ts"

import "./AfterSalesExchangeGood.vue?vue&type=style&index=0&id=705221aa&lang=scss&scoped=true"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-705221aa"]])

export default __exports__